import React from 'react';
import { Link } from 'react-router-dom';

interface AppSectionTabsProps {
  appId: string;
  active: 'overview' | 'commit';
  commitCount?: number;
  previewAppId?: string;
}

export const AppSectionTabs: React.FC<AppSectionTabsProps> = ({ appId, active, commitCount, previewAppId }) => {
  const commitPath = `/apps/${appId}/commit${previewAppId ? `?previewAppId=${encodeURIComponent(previewAppId)}` : ''}`;
  return (
    <nav className="change-tabs app-section-tabs" aria-label="App sections">
      {active === 'overview' ? <strong>Overview</strong> : <Link to={`/apps/${appId}`}>Overview</Link>}
      {active === 'commit'
        ? <strong>Commit{typeof commitCount === 'number' && <span>{commitCount}</span>}</strong>
        : <Link to={commitPath}>Commit</Link>}
    </nav>
  );
};
